import { useMutation, useQueryClient } from '@tanstack/react-query';
import api from '@/lib/api';
import { CreateProjectRequest, Project } from '@/types/project';
import toast from 'react-hot-toast';

async function createProject(data: CreateProjectRequest): Promise<Project> {
  const response = await api.post<{ data: Project }>('/projects', data);
  return response.data.data;
}

export function useCreateProject() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: createProject,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['projects'] });
      toast.success('Project created successfully!');
    },
    onError: (error: Error) => {
      toast.error(error.message || 'Failed to create project');
    },
  });
}
